// extracted by mini-css-extract-plugin
export default {"superlight-icon":"_superlight-icon_N35Nyh","attachments":"_attachments_hnHmey"};